import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { guardarCupomDoLink } from "@/lib/cupom-do-link";

// Link de divulgação (`?cupom=CODIGO`): guarda o cupom para o carrinho aplicar.
guardarCupomDoLink();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
